import axios from 'axios';
const URL_ROOT = '/';

export const sendOrder = (id,data) => {
    return new Promise((resolve, reject) => {
        axios.post(URL_ROOT + `allocation/store/${id}`,data).then(
            (response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            }
        )
    })
}
export const deleteOrder = (id,data) => {
    return new Promise((resolve, reject) => {
        axios.post(URL_ROOT + `allocation/delete/${id}`,data).then(
            (response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            }
        )
    })
}
export const updateOrder = (id,data) => {
    return new Promise((resolve, reject) => {
        axios.post(URL_ROOT + `allocation/update/${id}`,data).then(
            (response) => {
                resolve(response);
            },
            (error) => {
                reject(error);
            }
        )
    })
}